import styled, { css } from 'styled-components';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import {
  Breakpoint,
  FontWeight,
  FONT_STACK,
  LineHeight,
  STANDARD_TRANSITION,
} from '../../../common/styles/constants';
import { onMobile } from '../../../common/styles/onMobile';
import { responsiveInterpolate } from '../../../common/styles/responsiveInterpolate';

export const ResultListView = styled.div`
  ${FONT_STACK};
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
`;

export const AdventureTime = styled.div`
  align-items: flex-start;
  color: ${ThemeColours.mono800};
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: ${FontWeight.SEMI_BOLD};
  height: 52px;
  line-height: 17px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: ${responsiveInterpolate(0, 40)};

  ${Breakpoint.SMALL} {
    color: ${ThemeColours.black};
    font-size: 16px;
    font-weight: ${FontWeight.SEMI_BOLD};
    height: auto;
    line-height: ${LineHeight.LARGE};
    margin-bottom: 16px;
    padding-left: 0;
    padding-top: 24px;
  }
`;

export const Count = styled.div`
  color: ${ThemeColours.mono700};
  font-size: 14px;
  font-weight: ${FontWeight.SEMI_BOLD};

  ${Breakpoint.SMALL} {
    color: ${ThemeColours.black};
    margin-bottom: 16px;
  }
`;

export const ResultsContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-top: 8px;

  ${onMobile} {
    width: 100%;
  }
`;

export const ResultListContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  max-width: unset;

  ${onMobile} {
    width: 100%;
  }
`;

export const Results = styled.ul<{ isLoading: boolean }>`
  ${STANDARD_TRANSITION};
  list-style: none;
  margin: 0;
  padding: 0;

  ${onMobile} {
    width: 100%;
  }

  ${props =>
    props.isLoading &&
    css`
      opacity: 0.6;
    `}
`;

export const AdsContainer = styled.div`
  display: flex;
  justify-content: center;
`;
